export default __webpack_public_path__ + "static/media/back-arrow.fe014ba5.svg";